// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__27MJy","LoaderSpinner":"Loader_LoaderSpinner__1pUtT"};